import { render, staticRenderFns } from "./tutup_sementara.vue?vue&type=template&id=3552e3cd&scoped=true"
import script from "./tutup_sementara.vue?vue&type=script&lang=js"
export * from "./tutup_sementara.vue?vue&type=script&lang=js"
import style0 from "./tutup_sementara.vue?vue&type=style&index=0&id=3552e3cd&prod&lang=scss"
import style1 from "./tutup_sementara.vue?vue&type=style&index=1&id=3552e3cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3552e3cd",
  null
  
)

export default component.exports